import { BigNumber } from 'ethers'
import { useMemo } from 'react'
import { SymbolId } from 'types'
import { bn, e2w } from 'utils/number'
import { usePerpPositions } from '../../store/perp/hooks'

// The total USDT value of the maintenance margin for all positions.
export function useMaintenanceMargin(withoutId?: SymbolId): BigNumber {
  const positions = usePerpPositions()

  return useMemo(() => {
    if (!positions) return bn('0')
    return positions.reduce((prev, current): BigNumber => {
      if (withoutId && current.symbolId === withoutId) {
        return prev
      }
      return prev.add(e2w(current.minimumMaintenanceMargin))
    }, bn('0'))
  }, [positions, withoutId])
}
